<template>
  <v-dialog
    overlay-color="rgba(34, 34, 34, 0.27)"
    overlay-opacity="0.8"
    v-model="state"
    max-width="350"
    width="100%"
    persistent
  >
    <v-card class="upload-dialog">
      <v-card-title class="upload-dialog__title">Bulk Upload</v-card-title>

      <v-container class="mt-n2">
        <div class="upload-dialog__hint mb-2">
          Upload a <kbd class="kbd">csv</kbd> or <kbd class="kbd">excel</kbd>
          file
        </div>
        <v-row style="width: 100%;">
          <v-col cols="12">
            <v-file-input
              show-size
              v-model="file"
              class="font font-weight-medium"
              accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              label="Choose a file to upload"
            ></v-file-input>
            <span
              class="font-weight-medium text-wrap grey--text text--darken-4 font font-sm"
              >NB. Bulk uploads takes time to reflect</span
            >
          </v-col>
        </v-row>
        <!-- <div class="d-flex mx-1 flex-row flex-full">
          <v-btn
            x-small
            @click.stop="
              $store.dispatch('contact/fileDownload', {
                fileName: 'contacts',
                ext: 'xlsx',
              })
            "
            text
            outlined
            class="mx-1"
          >
            <span class="ft primary--text font-weight-bold font-size-sm"
              >Download Excel</span
            >
          </v-btn>
          <v-btn
            x-small
            text
            tag="a"
            target="_blank"
            outlined
            @click.stop="
              $store.dispatch('contact/fileDownload', {
                fileName: 'contacts',
                ext: 'csv',
              })
            "
          >
            <span class="ft primary--text font-weight-bold font-size-sm"
              >Download CSV</span
            >
          </v-btn>
        </div> -->
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text class="text-none" @click="action">
          Cancel
        </v-btn>

        <v-btn
          :disabled="!file || loading"
          :loading="loading"
          color="primary"
          depressed
          class="text-none upload-dialog__btn"
          @click="uploadFile"
        >
          Upload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BulkUpload",
  props: {
    state: {
      type: Boolean,
      required: true
    },
    loading: Boolean
  },
  data: () => ({
    file: null
  }),
  computed: {
    ...mapGetters({
      resetFormState: "getResetFormState"
    })
  },
  watch: {
    resetFormState(value) {
      if (value) {
        this.file = null;
      }
      setTimeout(() => {
        this.$store.dispatch("resetFormValues", false, { root: true });
      }, 1000);
    }
  },
  methods: {
    uploadFile() {
      this.$emit("uploadFile", this.file);
    },
    action() {
      this.$emit("actions", { idx: "add", status: false });
    }
  }
};
</script>

<style scoped>
.upload-dialog__title {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 600;
  color: var(--foreground);
}
.upload-dialog__hint {
  font-size: 14px;
  color: var(--muted-foreground);
  width: 100%;
}
.kbd {
  background: var(--muted);
  color: var(--foreground);
  border-radius: 6px;
  padding: 1px 6px;
  font-size: 12px;
  box-shadow: none;
}
.upload-dialog__btn {
  border-radius: var(--radius) !important;
  font-weight: 600;
}
</style>
